import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = ["variant", "onDismiss", "autoHideDelay", "autoHide", "transition", "duration"];
import React, { useCallback, useEffect, useRef } from 'react';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import Toast, { VARIANTS_NAMES } from "./Toast";
var slideAndPop = {
  entering: {
    transform: 'translate3d(120%, 0, 0)'
  },
  entered: {
    transform: 'translate3d(0,0,0)'
  },
  exiting: {
    transform: 'scale(0.66)',
    opacity: 0
  },
  exited: {
    transform: 'scale(0.66)',
    opacity: 0
  }
};
var collapse = {
  entering: 'auto',
  entered: 120,
  exiting: 0,
  exited: 'auto'
};
var useStyles = createUseStyles({
  toast: function toast(_ref) {
    var transition = _ref.transition,
        duration = _ref.duration;
    return _extends({
      transition: "transform ".concat(duration, "ms cubic-bezier(0.2, 0, 0, 1), opacity ").concat(duration, "ms")
    }, slideAndPop[transition]);
  },
  container: {
    transition: function transition(_ref2) {
      var duration = _ref2.duration;
      return "max-height ".concat(duration - 100, "ms 100ms");
    },
    maxHeight: function maxHeight(_ref3) {
      var transition = _ref3.transition;
      return collapse[transition];
    }
  }
});

var StackedToast = function StackedToast(_ref4) {
  var variant = _ref4.variant,
      onDismiss = _ref4.onDismiss,
      _ref4$autoHideDelay = _ref4.autoHideDelay,
      autoHideDelay = _ref4$autoHideDelay === void 0 ? 5000 : _ref4$autoHideDelay,
      _ref4$autoHide = _ref4.autoHide,
      autoHide = _ref4$autoHide === void 0 ? true : _ref4$autoHide,
      transition = _ref4.transition,
      duration = _ref4.duration,
      rest = _objectWithoutProperties(_ref4, _excluded);

  var timeout = useRef();
  var loadingVariant = variant === 'loading';

  var _useStyles = useStyles({
    autoHideDelay: autoHideDelay,
    transition: transition,
    duration: duration
  }),
      container = _useStyles.container,
      toast = _useStyles.toast;

  useEffect(function () {
    if (!loadingVariant && autoHide) {
      timeout.current = setTimeout(onDismiss, autoHideDelay);
      return function () {
        return timeout.current && clearTimeout(timeout.current);
      };
    }
  }, [loadingVariant, autoHide, onDismiss]);
  var dismiss = useCallback(function () {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    onDismiss();
  }, [onDismiss]);
  return /*#__PURE__*/React.createElement("div", {
    className: container,
    "data-qa": "stacked-toast"
  }, /*#__PURE__*/React.createElement(Toast, _extends({}, rest, {
    onDismiss: dismiss,
    variant: variant,
    className: toast
  })));
};

StackedToast.propTypes = {
  variant: PropTypes.oneOf(VARIANTS_NAMES).isRequired,
  onDismiss: PropTypes.func.isRequired,
  autoHideDelay: PropTypes.number,
  autoHide: PropTypes.bool,
  duration: PropTypes.number,
  transition: PropTypes.oneOf(['exited', 'exiting', 'entered', 'entering'])
};
export default StackedToast;